// The glance's "Find in model and sheets" link (root-04, contract
// 2026-09-19), read into what this page needs. All params optional:
//   glance=room:<id>|item:<level:system:x,y>
//                           resolved through GET /glance/locate (see
//                           targetFromLocate) - what the glance sends
//   q                       the text in the box, and the fallback search
//   room, roomName, level, levelName, uniqueId
//                           the structured target, looked up exactly
//   docId, page (1-based)   the sheet the room was read from - opened
//   sheetBox=x0,y0,x1,y1    its box on that page in PAGE PERCENT, y down
//   bbox + frame=building   its box in building feet (kept for the plan
//                           view; not drawn on a sheet)
//   from=glance
import { TARGET_KEYS } from "api/anchors/anchorApi";

const nums = (v) => {
  const a = String(v || "").split(",").map((x) => Number(x));
  return a.length === 4 && a.every(Number.isFinite) ? a : null;
};

export function linkTargetOf(search) {
  let p;
  try { p = new URLSearchParams(search || ""); } catch (e) { p = new URLSearchParams(); }
  const get = (k) => String(p.get(k) || "").trim();
  const target = {};
  TARGET_KEYS.forEach((k) => { const v = get(k).slice(0, 200); if (v) target[k] = v; });
  const docId = /^[0-9a-f]{24}$/i.test(get("docId")) ? get("docId") : "";
  const page1 = Math.max(1, parseInt(get("page"), 10) || 1);
  const pct = nums(get("sheetBox"));
  const sheetBox = pct && pct[2] > pct[0] && pct[3] > pct[1]
    ? pct.map((v) => Math.min(100, Math.max(0, v))) : null;
  const bbox = get("frame") === "building" ? nums(get("bbox")) : null;
  return {
    q: get("q"),
    from: get("from"),
    glance: /^(room|item):.+/.test(get("glance")) ? get("glance").slice(0, 240) : "",
    target: Object.keys(target).length ? target : null,
    // 0-based, as the anchors and the canvas count pages.
    sheet: docId ? { docId, page: page1 - 1 } : null,
    sheetBox: docId ? sheetBox : null,
    buildingBox: bbox,
  };
}

// GET /glance/locate's answer -> the search target, the sheet to open and
// the box on it. The sheet is the first source registered to the building
// (it has a box), else the first source at all.
export function targetFromLocate(loc) {
  if (!loc || !loc.kind) return null;
  const target = {};
  const put = (k, v) => { if (v != null && String(v).trim()) target[k] = String(v).trim().slice(0, 200); };
  if (loc.kind === "room") {
    put("roomId", loc.id); put("room", loc.number); put("roomName", loc.name);
  } else {
    put("itemKey", loc.id);
  }
  put("level", loc.level); put("levelName", loc.levelName); put("uniqueId", loc.uniqueId);
  const sources = (Array.isArray(loc.sources) ? loc.sources : []).filter((x) => x && /^[0-9a-f]{24}$/i.test(String(x.docId)));
  const src = sources.find((x) => x.placed && nums((x.box || []).join(","))) || sources[0] || null;
  const sheet = src ? { docId: String(src.docId), page: Math.max(1, Number(src.page) || 1) - 1 } : null;
  const box = src && nums((src.box || []).join(","));
  return {
    target,
    sheet,
    sheetBox: box && box[2] > box[0] && box[3] > box[1] ? box.map((v) => Math.min(100, Math.max(0, v))) : null,
    buildingBox: nums((loc.bbox || []).join(",")),
    label: loc.label || "",
  };
}
